export const FORMS: any[] = [
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "catalogName", "useQuickAdd", "styleSheet", "headerLogo", "contentPathPrefix", "templatePathPrefix", "viewAllowPermReqd", "purchaseAllowPermReqd" ]
    } ],
    "formName" : "Catalog",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "single",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "Catalog_prodCatalogId",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "catalogName",
      "action" : "",
      "id" : "Catalog_catalogName",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "useQuickAdd",
      "action" : "",
      "id" : "Catalog_useQuickAdd",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "styleSheet",
      "action" : "",
      "id" : "Catalog_styleSheet",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "headerLogo",
      "action" : "",
      "id" : "Catalog_headerLogo",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "contentPathPrefix",
      "action" : "",
      "id" : "Catalog_contentPathPrefix",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "templatePathPrefix",
      "action" : "",
      "id" : "Catalog_templatePathPrefix",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "viewAllowPermReqd",
      "action" : "",
      "id" : "Catalog_viewAllowPermReqd",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "conditionGroup" : "",
      "name" : "purchaseAllowPermReqd",
      "action" : "",
      "id" : "Catalog_purchaseAllowPermReqd",
      "type" : "DISPLAY",
      "event" : "",
      "value" : ""
    }, {
      "fieldHelpText" : "This cannot be changed without re-creating the Product Catalog.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "prodCatalogId",
      "description" : "",
      "style" : "",
      "id" : "Catalog_prodCatalogId",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "This will be shown to your customers, so think of image when giving your catalog a name.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "catalogName",
      "description" : "",
      "style" : "",
      "id" : "Catalog_catalogName",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "Set this to Y if you want to give users the option to quick add products.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "useQuickAdd",
      "description" : "",
      "style" : "",
      "id" : "Catalog_useQuickAdd",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "The path to your distinctive style sheet which will govern the appearance of your catalog goes here.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "styleSheet",
      "description" : "",
      "style" : "",
      "id" : "Catalog_styleSheet",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "This will be seen by your customers. Maintain your image and message with the logo presented.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "headerLogo",
      "description" : "",
      "style" : "",
      "id" : "Catalog_headerLogo",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "If specified will be prepended to image and other content paths. Should start with a slash but not end with one.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "contentPathPrefix",
      "description" : "",
      "style" : "",
      "id" : "Catalog_contentPathPrefix",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "If specified will be prepended to template paths. Should start with a slash but not end with one.",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "templatePathPrefix",
      "description" : "",
      "style" : "",
      "id" : "Catalog_templatePathPrefix",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "If Y, administrators can only add products to 'View Allow' categories if they have the permission CATALOG_VIEW_ALLOW",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "viewAllowPermReqd",
      "description" : "",
      "style" : "",
      "id" : "Catalog_viewAllowPermReqd",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "If Y, administrators can only add products to 'Purchase Allow' categories if they have the permission CATALOG_VIEW_ALLOW",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "purchaseAllowPermReqd",
      "description" : "",
      "style" : "",
      "id" : "Catalog_purchaseAllowPermReqd",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    } ],
    "target" : ""
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "catalogName", "useQuickAdd" ]
    } ],
    "columns" : [ {
      "name" : "prodCatalogId",
      "title" : "Prod Catalog ID"
    }, {
      "name" : "catalogName",
      "title" : "Catalog Name"
    }, {
      "name" : "useQuickAdd",
      "title" : "Use Quick Add"
    } ],
    "formName" : "ListCatalog",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "list",
    "fields" : [ {
      "image" : "",
      "fieldHelpText" : "",
      "alternate" : "",
      "description" : "",
      "type" : "HYPERLINK",
      "target" : "EditCatalog",
      "isSortField" : "Y",
      "width" : "",
      "name" : "prodCatalogId",
      "parameterList" : [ {
        "name" : "prodCatalogId",
        "value" : {
          "chars" : "${prodCatalogId}",
          "hint" : 20,
          "offset" : 0,
          "length" : 16,
          "bracketedOriginal" : "${prodCatalogId}",
          "empty" : false,
          "original" : "${prodCatalogId}"
        }
      } ],
      "style" : "",
      "id" : "ListCatalog_prodCatalogId",
      "imageTitle" : "",
      "parameterMap" : {
        "prodCatalogId" : ""
      },
      "height" : "",
      "event":"edit",
      "formData":{
          "formName":"EditProdCatalog",
          "formLocation":"component://kwikstore/widget/ProdCatalogForms.xml",
      },
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "isSortField" : "Y",
      "size" : 0,
      "name" : "catalogName",
      "description" : "",
      "style" : "",
      "id" : "ListCatalog_catalogName",
      "type" : "DISPLAY",
      "title" : "",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "isSortField" : "Y",
      "size" : 0,
      "name" : "useQuickAdd",
      "description" : "",
      "style" : "",
      "id" : "ListCatalog_useQuickAdd",
      "type" : "DISPLAY",
      "title" : "",
      "imageLocation" : ""
    } ],
    "target" : ""
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "prodCatalogId", "prodCatalogId", "prodCatalogId", "catalogName", "useQuickAdd", "styleSheet", "headerLogo", "contentPathPrefix", "templatePathPrefix", "viewAllowPermReqd", "purchaseAllowPermReqd", "submitButton" ]
    } ],
    "formName" : "EditProdCatalog",
    "targets":{
      "createTarget" : "createProdCatalog",
      "updateTarget" : "updateProdCatalog"
    },
    "altTarget" : [ {
      "useWhen" : "prodCatalog==null",
      "targetExdr" : {
        "chars" : "createProdCatalog",
        "hint" : 20,
        "empty" : false,
        "original" : "createProdCatalog"
      }
    } ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "single",
    "fields" : [ {
      "" : "",
      "fieldHelpText" : "This cannot be changed without re-creating the Product Catalog.",
      "textSize" : "20",
      "ajaxUrl" : "",
      "maxlength" : "20",
      "tabindex" : "",
      "className" : "",
      "title" : "Catalog [ID]",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "prodCatalogId",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_prodCatalogId",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "This will be shown to your customers, so think of image when giving your catalog a name.",
      "textSize" : "30",
      "ajaxUrl" : "",
      "maxlength" : "60",
      "tabindex" : "",
      "className" : "required",
      "title" : "Catalog Name",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "catalogName",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_catalogName",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Use Quick Add",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "Y",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "EditProdCatalog",
      "options" : [ {
        "description" : "Y",
        "key" : "Y"
      }, {
        "description" : "N",
        "key" : "N"
      } ],
      "disabled" : "false",
      "id" : "EditProdCatalog_useQuickAdd",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "Set this to Y if you want to give users the option to quick add products.",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "useQuickAdd",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "" : "",
      "fieldHelpText" : "The path to your distinctive style sheet which will govern the appearance of your catalog goes here.",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Style Sheet",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "styleSheet",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_styleSheet",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "This will be seen by your customers. Maintain your image and message with the logo presented.",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Header Logo",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "headerLogo",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_headerLogo",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "If specified will be prepended to image and other content paths. Should start with a slash but not end with one.",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Content Path Prefix",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "contentPathPrefix",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_contentPathPrefix",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "" : "",
      "fieldHelpText" : "If specified will be prepended to template paths. Should start with a slash but not end with one.",
      "textSize" : "60",
      "ajaxUrl" : "",
      "maxlength" : "250",
      "tabindex" : "",
      "className" : "",
      "title" : "Template Path Prefix",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "templatePathPrefix",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalog_templatePathPrefix",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Permission required to add product to \"ViewAllow\" category",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "N",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "EditProdCatalog",
      "options" : [ {
        "description" : "Y",
        "key" : "Y"
      }, {
        "description" : "N",
        "key" : "N"
      } ],
      "disabled" : "false",
      "id" : "EditProdCatalog_viewAllowPermReqd",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "If Y, administrators can only add products to 'View Allow' categories if they have the permission CATALOG_VIEW_ALLOW",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "viewAllowPermReqd",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Permission required to add product to \"PurchaseAllow\" category",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "N",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "EditProdCatalog",
      "options" : [ {
        "description" : "Y",
        "key" : "Y"
      }, {
        "description" : "N",
        "key" : "N"
      } ],
      "disabled" : "false",
      "id" : "EditProdCatalog_purchaseAllowPermReqd",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "If Y, administrators can only add products to 'Purchase Allow' categories if they have the permission CATALOG_VIEW_ALLOW",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "purchaseAllowPermReqd",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "EditProdCatalog",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "EditProdCatalog_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "updateProdCatalog"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "roleTypeId", "prodCatalogId", "fromDate", "thruDate", "sequenceNum", "submitButton", "deleteLink" ]
    } ],
    "columns" : [ {
      "name" : "partyId",
      "title" : "Party"
    }, {
      "name" : "roleTypeId",
      "title" : "Role"
    }, {
      "name" : "fromDate",
      "title" : "From Date  Time"
    }, {
      "name" : "thruDate",
      "title" : "Through Date  Time"
    }, {
      "name" : "sequenceNum",
      "title" : "Sequence Num"
    }, {
      "name" : "submitButton",
      "title" : "Update"
    }, {
      "name" : "deleteLink",
      "title" : " "
    } ],
    "formName" : "UpdateProdCatalogToParty",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "list",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "UpdateProdCatalogToParty_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "hyperlink" : {
        "linkStyle" : "buttontext",
        "description" : "",
        "targetType" : "inter-app",
        "confirmation" : "",
        "parameterMap" : {
          "VIEW_SIZE_0" : "20",
          "VIEW_INDEX_0" : "0"
        },
        "uniqueItemName" : "Modal_2f5d9948_dd60_4686_8999_fc433d65fa4b",
        "target" : "/partymgr/control/viewprofile",
        "targetWindow" : "",
        "remoteFormData":{
            "formData":{
                "formName":"EditCategory",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/categories/category/${productCategoryId}"
            }
        },
      },
      "event": "custom",
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "partyId",
      "description" : "",
      "style" : "",
      "id" : "UpdateProdCatalogToParty_partyId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "roleTypeId",
      "description" : "",
      "style" : "",
      "id" : "UpdateProdCatalogToParty_roleTypeId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "fromDate",
      "description" : "",
      "style" : "",
      "id" : "UpdateProdCatalogToParty_fromDate",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2005:02:46.028",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "UpdateProdCatalogToParty",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "UpdateProdCatalogToParty_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "UpdateProdCatalogToParty_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "UpdateProdCatalogToParty",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "UpdateProdCatalogToParty_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "deleteLink",
      "alternate" : "",
      "description" : "Delete",
      "parameterList" : [ {
        "name" : "prodCatalogId"
      }, {
        "name" : "partyId"
      }, {
        "name" : "roleTypeId"
      }, {
        "name" : "fromDate"
      } ],
      "id" : "UpdateProdCatalogToParty_deleteLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : "",
      "target" : "removeProdCatalogFromParty"
    } ],
    "target" : "updateProdCatalogToParty"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "roleTypeId", "prodCatalogId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
    } ],
    "formName" : "AddProdCatalogToParty",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "single",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "AddProdCatalogToParty_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "fieldHelpText" : "",
      "lookupOptions" : {
        "ajaxUrl" : "",
        "fadeBackground" : "true",
        "conditionGroup" : "",
        "targetParameterList" : [ "" ],
        "className" : "",
        "type" : "LOOKUP",
        "presentation" : "layer",
        "initiallyCollapsed" : "false",
        "ajaxEnabled" : "true",
        "showDescription" : "true",
        "delegatorName" : "",
        "readonly" : "false",
        "alert" : "false",
        "formName" : "AddProdCatalogToParty",
        "id" : "AddProdCatalogToParty_partyId",
        "event" : "",
        "value" : "",
        "fieldFormName" : "LookupPartyName",
        "maxlength" : "",
        "autocomplete" : "",
        "clearText" : "Clear",
        "tabindex" : "",
        "size" : "25",
        "name" : "partyId",
        "descriptionFieldName" : "",
        "position" : "topleft",
        "imgSrc" : ""
      },
      "name" : "partyId",
      "style" : "",
      "id" : "AddProdCatalogToParty_partyId",
      "title" : "Party ID",
      "type" : "LOOKUP"
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Role",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "_NA_",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "AddProdCatalogToParty",
      "options" : [ {
        "description" : "Account",
        "key" : "ACCOUNT"
      }, {
        "description" : "Account Lead",
        "key" : "ACCOUNT_LEAD"
      }, {
        "description" : "Accountant",
        "key" : "ACCOUNTANT"
      }, {
        "description" : "Addressee",
        "key" : "ADDRESSEE"
      }, {
        "description" : "Administrator",
        "key" : "ADMIN"
      }, {
        "description" : "Affiliate",
        "key" : "AFFILIATE"
      }, {
        "description" : "Agent",
        "key" : "AGENT"
      }, {
        "description" : "Approver",
        "key" : "APPROVER"
      }, {
        "description" : "Association",
        "key" : "ASSOCIATION"
      }, {
        "description" : "Automated Agent",
        "key" : "AUTOMATED_AGENT_ROLE"
      }, {
        "description" : "Bill-From-Vendor",
        "key" : "BILL_FROM_VENDOR"
      }, {
        "description" : "Bill-To Customer",
        "key" : "BILL_TO_CUSTOMER"
      }, {
        "description" : "Blind Copy",
        "key" : "BCC"
      }, {
        "description" : "Budget Application",
        "key" : "BUDGET_APPL"
      }, {
        "description" : "Budget Approver",
        "key" : "BUDGET_APPRV"
      }, {
        "description" : "Budget Manager",
        "key" : "BUDGET_MGR"
      }, {
        "description" : "Budget Reviewer",
        "key" : "BUDGET_RVR"
      }, {
        "description" : "Budget Roles Group (not to be assigned to parties)",
        "key" : "BUDGET"
      }, {
        "description" : "Bulk Customer",
        "key" : "BULK_CUSTOMER"
      }, {
        "description" : "Buyer",
        "key" : "BUYER"
      }, {
        "description" : "Calendar",
        "key" : "CALENDAR_ROLE"
      }, {
        "description" : "Calendar Attendee",
        "key" : "CAL_ATTENDEE"
      }, {
        "description" : "Calendar Delegate",
        "key" : "CAL_DELEGATE"
      }, {
        "description" : "Calendar Host",
        "key" : "CAL_HOST"
      }, {
        "description" : "Calendar Member",
        "key" : "ICAL_MEMBER"
      }, {
        "description" : "Calendar Organizer",
        "key" : "CAL_ORGANIZER"
      }, {
        "description" : "Calendar Owner",
        "key" : "CAL_OWNER"
      }, {
        "description" : "Carbon Copy",
        "key" : "CC"
      }, {
        "description" : "Carrier",
        "key" : "CARRIER"
      }, {
        "description" : "Cashier",
        "key" : "CASHIER"
      }, {
        "description" : "Client",
        "key" : "CLIENT"
      }, {
        "description" : "Client Analyst",
        "key" : "CLIENT_ANALYST"
      }, {
        "description" : "Client Billing",
        "key" : "CLIENT_BILLING"
      }, {
        "description" : "Client Manager",
        "key" : "CLIENT_MANAGER"
      }, {
        "description" : "Communication Participant",
        "key" : "COMMEVENT_ROLE"
      }, {
        "description" : "Competitor",
        "key" : "COMPETITOR"
      }, {
        "description" : "Consumer",
        "key" : "CONSUMER"
      }, {
        "description" : "Contact",
        "key" : "CONTACT"
      }, {
        "description" : "Content Administrator",
        "key" : "CONTENT_ADMIN"
      }, {
        "description" : "Content Author",
        "key" : "CONTENT_AUTHOR"
      }, {
        "description" : "Content Editor",
        "key" : "CONTENT_EDITOR"
      }, {
        "description" : "Content Guest",
        "key" : "CONTENT_GUEST"
      }, {
        "description" : "Content Member",
        "key" : "CONTENT"
      }, {
        "description" : "Content Publisher",
        "key" : "CONTENT_PUBLISHER"
      }, {
        "description" : "Content User",
        "key" : "CONTENT_USER"
      }, {
        "description" : "Contractor",
        "key" : "CONTRACTOR"
      }, {
        "description" : "Customer",
        "key" : "CUSTOMER"
      }, {
        "description" : "Department",
        "key" : "DEPARTMENT"
      }, {
        "description" : "Distribution Channel",
        "key" : "DISTRIBUTION_CHANNEL"
      }, {
        "description" : "Distributor",
        "key" : "DISTRIBUTOR"
      }, {
        "description" : "Division",
        "key" : "DIVISION"
      }, {
        "description" : "Email Administrator",
        "key" : "EMAIL_ADMIN"
      }, {
        "description" : "Employee",
        "key" : "EMPLOYEE"
      }, {
        "description" : "Employer",
        "key" : "EMPLOYER"
      }, {
        "description" : "End-User Customer",
        "key" : "END_USER_CUSTOMER"
      }, {
        "description" : "Family Member",
        "key" : "FAMILY_MEMBER"
      }, {
        "description" : "Fixed Asset Maint Assignee",
        "key" : "FAM_ASSIGNEE"
      }, {
        "description" : "Government Agency",
        "key" : "GOV_AGENCY"
      }, {
        "description" : "Hosting Server",
        "key" : "HOSTING_SERVER"
      }, {
        "description" : "Household",
        "key" : "HOUSEHOLD"
      }, {
        "description" : "ISP",
        "key" : "ISP"
      }, {
        "description" : "Image Approver",
        "key" : "IMAGEAPPROVER"
      }, {
        "description" : "Internal Organization",
        "key" : "INTERNAL_ORGANIZATIO"
      }, {
        "description" : "Lead",
        "key" : "LEAD"
      }, {
        "description" : "Limited Administrator",
        "key" : "LTD_ADMIN"
      }, {
        "description" : "Logged In",
        "key" : "LOGGEDIN"
      }, {
        "description" : "Main Role",
        "key" : "MAIN_ROLE"
      }, {
        "description" : "Maintenance Manager or Supervisor",
        "key" : "FAM_MANAGER"
      }, {
        "description" : "Maintenance Supplier or Service",
        "key" : "FAM_SUPPLIER"
      }, {
        "description" : "Maintenance Worker",
        "key" : "FAM_WORKER"
      }, {
        "description" : "Manager",
        "key" : "MANAGER"
      }, {
        "description" : "Manufacturer",
        "key" : "MANUFACTURER"
      }, {
        "description" : "Not Applicable",
        "key" : "_NA_"
      }, {
        "description" : "Order Clerk",
        "key" : "ORDER_CLERK"
      }, {
        "description" : "Organization",
        "key" : "ORGANIZATION_ROLE"
      }, {
        "description" : "Organization Unit",
        "key" : "ORGANIZATION_UNIT"
      }, {
        "description" : "Originator",
        "key" : "ORIGINATOR"
      }, {
        "description" : "Other Internal",
        "key" : "OTHER_INTERNAL_ORGAN"
      }, {
        "description" : "Other Organization Unit",
        "key" : "OTHER_ORGANIZATION_U"
      }, {
        "description" : "Owner",
        "key" : "OWNER"
      }, {
        "description" : "Packer",
        "key" : "PACKER"
      }, {
        "description" : "Parent Organization",
        "key" : "PARENT_ORGANIZATION"
      }, {
        "description" : "Partner",
        "key" : "PARTNER"
      }, {
        "description" : "Person",
        "key" : "PERSON_ROLE"
      }, {
        "description" : "Picker",
        "key" : "PICKER"
      }, {
        "description" : "Placing Customer",
        "key" : "PLACING_CUSTOMER"
      }, {
        "description" : "Product Owner",
        "key" : "PRODUCT_OWNER"
      }, {
        "description" : "Product Owner Company",
        "key" : "PRODUCT_OWNER_COMP"
      }, {
        "description" : "Project Team",
        "key" : "PROJECT_TEAM"
      }, {
        "description" : "Prospect",
        "key" : "PROSPECT"
      }, {
        "description" : "Provider Accounting",
        "key" : "PROVIDER_ACCOUNTING"
      }, {
        "description" : "Provider Analyst",
        "key" : "PROVIDER_ANALYST"
      }, {
        "description" : "Provider Functional",
        "key" : "PROVIDER_FUNCTIONAL"
      }, {
        "description" : "Provider Manager",
        "key" : "PROVIDER_MANAGER"
      }, {
        "description" : "Provider Tester",
        "key" : "PROVIDER_TESTER"
      }, {
        "description" : "Provider Validator",
        "key" : "PROVIDER_VALIDATOR"
      }, {
        "description" : "Receiver",
        "key" : "RECEIVER"
      }, {
        "description" : "Referrer",
        "key" : "REFERRER"
      }, {
        "description" : "Regulatory Agency",
        "key" : "REGULATORY_AGENCY"
      }, {
        "description" : "Request Manager",
        "key" : "REQ_MANAGER"
      }, {
        "description" : "Request Respondent",
        "key" : "REQ_RESPOND"
      }, {
        "description" : "Request Role",
        "key" : "REQUEST_ROLE"
      }, {
        "description" : "Request Taker",
        "key" : "REQ_TAKER"
      }, {
        "description" : "Requesting Party",
        "key" : "REQ_REQUESTER"
      }, {
        "description" : "Reviewer",
        "key" : "REVIEWER"
      }, {
        "description" : "SCRUM Master",
        "key" : "SCRUM_MASTER"
      }, {
        "description" : "SCRUM Team",
        "key" : "SCRUM_TEAM"
      }, {
        "description" : "Sales Force Autm.",
        "key" : "SFA_ROLE"
      }, {
        "description" : "Sales Representative",
        "key" : "SALES_REP"
      }, {
        "description" : "Scrum Member",
        "key" : "SCRUM_MEMBER"
      }, {
        "description" : "Shareholder",
        "key" : "SHAREHOLDER"
      }, {
        "description" : "Ship-From Vendor",
        "key" : "SHIP_FROM_VENDOR"
      }, {
        "description" : "Ship-To Customer",
        "key" : "SHIP_TO_CUSTOMER"
      }, {
        "description" : "Shipment Clerk",
        "key" : "SHIPMENT_CLERK"
      }, {
        "description" : "Sponsor",
        "key" : "SPONSOR"
      }, {
        "description" : "Spouse",
        "key" : "SPOUSE"
      }, {
        "description" : "Stakeholder",
        "key" : "STAKEHOLDER"
      }, {
        "description" : "Stocker",
        "key" : "STOCKER"
      }, {
        "description" : "Subscriber",
        "key" : "SUBSCRIBER"
      }, {
        "description" : "Subsidiary",
        "key" : "SUBSIDIARY"
      }, {
        "description" : "Supplier",
        "key" : "SUPPLIER"
      }, {
        "description" : "Supplier Agent",
        "key" : "SUPPLIER_AGENT"
      }, {
        "description" : "Tax Authority",
        "key" : "TAX_AUTHORITY"
      }, {
        "description" : "Union",
        "key" : "UNION"
      }, {
        "description" : "Vendor",
        "key" : "VENDOR"
      }, {
        "description" : "Visitor",
        "key" : "VISITOR"
      }, {
        "description" : "Web Master",
        "key" : "WEB_MASTER"
      }, {
        "description" : "Worker",
        "key" : "WORKER"
      }, {
        "description" : "Workflow",
        "key" : "WORKFLOW_ROLE"
      }, {
        "description" : "Workflow Owner",
        "key" : "WF_OWNER"
      } ],
      "disabled" : "false",
      "id" : "AddProdCatalogToParty_roleTypeId",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "roleTypeId",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "From Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:29:40.004",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProdCatalogToParty",
      "timeDropdownParamName" : "fromDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProdCatalogToParty_fromDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "fromDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:29:40.005",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProdCatalogToParty",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProdCatalogToParty_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "AddProdCatalogToParty_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "AddProdCatalogToParty",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "AddProdCatalogToParty_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Add",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "addProdCatalogToParty"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "prodCatalogId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
    } ],
    "formName" : "CreateProductStoreCatalog",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "single",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "CreateProductStoreCatalog_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Store",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "CreateProductStoreCatalog",
      "options" : [ {
        "description" : "Flowers All Over",
        "key" : "10140"
      }, {
        "description" : "High Five",
        "key" : "10170"
      }, {
        "description" : "Kwikstore",
        "key" : "KWIKSTORE"
      }, {
        "description" : "Louis Stores",
        "key" : "10131"
      }, {
        "description" : "Loving This",
        "key" : "10180"
      }, {
        "description" : "Lucky Stores",
        "key" : "10181"
      }, {
        "description" : "My Store",
        "key" : "10150"
      }, {
        "description" : "OFBiz E-Commerce Store",
        "key" : "9000"
      }, {
        "description" : "OFBiz Physical Retail Store",
        "key" : "9100"
      }, {
        "description" : "Open Travel system Demo Site",
        "key" : "RentalStore"
      }, {
        "description" : "Revolution",
        "key" : "10197"
      }, {
        "description" : "Some Name",
        "key" : "10220"
      }, {
        "description" : "Some Name",
        "key" : "10209"
      }, {
        "description" : "Some Name",
        "key" : "10206"
      }, {
        "description" : "Some Name",
        "key" : "10190"
      }, {
        "description" : "Some Name",
        "key" : "10186"
      }, {
        "description" : "Some Name",
        "key" : "10185"
      }, {
        "description" : "Some Name",
        "key" : "10182"
      }, {
        "description" : "Some Store",
        "key" : "10221"
      }, {
        "description" : "Some Store",
        "key" : "10207"
      }, {
        "description" : "Some Store",
        "key" : "10205"
      }, {
        "description" : "Some Store",
        "key" : "10130"
      }, {
        "description" : "State Capture",
        "key" : "10196"
      }, {
        "description" : "Store of lies",
        "key" : "10195"
      }, {
        "description" : "Test Store 1",
        "key" : "10210"
      }, {
        "description" : "Test Store 1",
        "key" : "10204"
      }, {
        "description" : "Test Store 1",
        "key" : "10203"
      }, {
        "description" : "Test Store 1",
        "key" : "10199"
      }, {
        "description" : "Test Store 1",
        "key" : "10193"
      }, {
        "description" : "Test Store 1",
        "key" : "10192"
      }, {
        "description" : "Test Store 1",
        "key" : "10191"
      }, {
        "description" : "Test Store 1",
        "key" : "10184"
      }, {
        "description" : "Test Store 2",
        "key" : "10202"
      }, {
        "description" : "Test Store 2",
        "key" : "10200"
      }, {
        "description" : "Test Store 2",
        "key" : "10187"
      }, {
        "description" : "Test Store 2",
        "key" : "10183"
      }, {
        "description" : "Test Store 2",
        "key" : "10020"
      }, {
        "description" : "Test Store 3",
        "key" : "10030"
      }, {
        "description" : "Test Store 4",
        "key" : "10040"
      }, {
        "description" : "Test Store 5",
        "key" : "10050"
      }, {
        "description" : "Test Store 6",
        "key" : "10208"
      }, {
        "description" : "Test Store 6",
        "key" : "10201"
      }, {
        "description" : "Test Store 6",
        "key" : "10198"
      }, {
        "description" : "Test Store 6",
        "key" : "10189"
      }, {
        "description" : "Test Store 6",
        "key" : "10188"
      }, {
        "description" : "Test Store 6",
        "key" : "10120"
      }, {
        "description" : "Test Store 6",
        "key" : "10110"
      }, {
        "description" : "Test Store 6",
        "key" : "10100"
      }, {
        "description" : "Test Store 6",
        "key" : "10090"
      }, {
        "description" : "Test Store 6",
        "key" : "10080"
      }, {
        "description" : "Test Store 6",
        "key" : "10070"
      }, {
        "description" : "Test Store 6",
        "key" : "10060"
      }, {
        "description" : "This Store",
        "key" : "10160"
      }, {
        "description" : "Zulu Twak",
        "key" : "10194"
      } ],
      "disabled" : "false",
      "id" : "CreateProductStoreCatalog_productStoreId",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "productStoreId",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "From Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:32:41.56",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "CreateProductStoreCatalog",
      "timeDropdownParamName" : "fromDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "CreateProductStoreCatalog_fromDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "fromDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:32:41.56",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "CreateProductStoreCatalog",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "CreateProductStoreCatalog_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "CreateProductStoreCatalog_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "CreateProductStoreCatalog",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "CreateProductStoreCatalog_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Add",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "createProdCatalogStore"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "productCategoryId", "prodCatalogCategoryTypeId", "fromDate", "thruDate", "sequenceNum", "submitButton" ]
    } ],
    "formName" : "AddProductCategoryToProdCatalog",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "single",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "AddProductCategoryToProdCatalog_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "fieldHelpText" : "",
      "lookupOptions" : {
        "ajaxUrl" : "",
        "fadeBackground" : "true",
        "conditionGroup" : "",
        "targetParameterList" : [ "" ],
        "className" : "",
        "type" : "LOOKUP",
        "presentation" : "layer",
        "initiallyCollapsed" : "false",
        "ajaxEnabled" : "true",
        "showDescription" : "true",
        "delegatorName" : "",
        "readonly" : "false",
        "alert" : "false",
        "formName" : "AddProductCategoryToProdCatalog",
        "id" : "AddProductCategoryToProdCatalog_productCategoryId",
        "event" : "",
        "value" : "",
        "fieldFormName" : "LookupProductCategory",
        "maxlength" : "",
        "autocomplete" : "",
        "clearText" : "Clear",
        "tabindex" : "",
        "size" : "25",
        "name" : "productCategoryId",
        "descriptionFieldName" : "",
        "position" : "topleft",
        "imgSrc" : ""
      },
      "name" : "productCategoryId",
      "style" : "",
      "id" : "AddProductCategoryToProdCatalog_productCategoryId",
      "title" : "Category ID",
      "type" : "LOOKUP"
    }, {
      "fieldName" : "",
      "firstInList" : "",
      "partialChars" : "",
      "conditionGroup" : "",
      "otherFieldName" : "",
      "className" : "",
      "title" : "Product Catalog Category Type",
      "type" : "DROP_DOWN",
      "frequency" : "",
      "minChars" : "",
      "allowEmpty" : "",
      "autoSelect" : "",
      "ajaxEnabled" : "false",
      "noCurrentSelectedKey" : "",
      "ajaxOptions" : "",
      "alert" : "false",
      "otherFieldSize" : "0",
      "ignoreCase" : "",
      "formName" : "AddProductCategoryToProdCatalog",
      "options" : [ {
        "description" : "Admin Allow (One)",
        "key" : "PCCT_ADMIN_ALLW"
      }, {
        "description" : "Best Selling (One)",
        "key" : "PCCT_BEST_SELL"
      }, {
        "description" : "Browse Root (One)",
        "key" : "PCCT_BROWSE_ROOT"
      }, {
        "description" : "Default Search (One)",
        "key" : "PCCT_SEARCH"
      }, {
        "description" : "Ebay Root (One)",
        "key" : "PCCT_EBAY_ROOT"
      }, {
        "description" : "Most Popular (One)",
        "key" : "PCCT_MOST_POPULAR"
      }, {
        "description" : "Other Search (Many)",
        "key" : "PCCT_OTHER_SEARCH"
      }, {
        "description" : "Promotions (One)",
        "key" : "PCCT_PROMOTIONS"
      }, {
        "description" : "Purchase Allow (One)",
        "key" : "PCCT_PURCH_ALLW"
      }, {
        "description" : "Quick Add (Many)",
        "key" : "PCCT_QUICK_ADD"
      }, {
        "description" : "Template",
        "key" : "PCCT_TEMPL"
      }, {
        "description" : "View Allow (One)",
        "key" : "PCCT_VIEW_ALLW"
      }, {
        "description" : "What\\'s New (One per catalog)",
        "key" : "PCCT_WHATS_NEW"
      } ],
      "disabled" : "false",
      "id" : "AddProductCategoryToProdCatalog_prodCatalogCategoryTypeId",
      "event" : "",
      "otherValue" : "",
      "fullSearch" : "",
      "fieldHelpText" : "",
      "dDFCurrent" : "selected",
      "tabindex" : "",
      "multiple" : "",
      "partialSearch" : "",
      "size" : "1",
      "name" : "prodCatalogCategoryTypeId",
      "style" : "",
      "explicitDescription" : "",
      "choices" : "",
      "currentValue" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "From Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:35:13.727",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProductCategoryToProdCatalog",
      "timeDropdownParamName" : "fromDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProductCategoryToProdCatalog_fromDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "fromDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:35:13.727",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "AddProductCategoryToProdCatalog",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "AddProductCategoryToProdCatalog_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "AddProductCategoryToProdCatalog_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "AddProductCategoryToProdCatalog",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "AddProductCategoryToProdCatalog_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Add",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "addProductCategoryToProdCatalog"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "prodCatalogId", "fromDate", "thruDate", "sequenceNum", "submitButton", "deleteLink" ]
    } ],
    "columns" : [ {
      "name" : "productStoreId",
      "title" : "Store ID"
    }, {
      "name" : "fromDate",
      "title" : "From Date  Time"
    }, {
      "name" : "thruDate",
      "title" : "Through Date  Time"
    }, {
      "name" : "sequenceNum",
      "title" : "Sequence Num"
    }, {
      "name" : "submitButton",
      "title" : "Update"
    }, {
      "name" : "deleteLink",
      "title" : " "
    } ],
    "formName" : "UpdateProductStoreCatalog",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "list",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "UpdateProductStoreCatalog_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "hyperlink" : {
        "linkStyle" : "buttontext",
        "description" : "",
        "targetType" : "intra-app",
        "confirmation" : "",
        "parameterMap" : {
          "VIEW_SIZE_0" : "20",
          "VIEW_INDEX_0" : "0"
        },
        "uniqueItemName" : "Modal_31d746fb_1286_4f74_b94f_2b23d1934818",
        "target" : "EditProductStore",
        "targetWindow" : "",
        "remoteFormData":{
            "formData":{
                "formName":"EditProductStore",
                "formLocation":"component://kwikstore/widget/StoreForms.xml",
                "link":"/admin/stores/store/${productStoreId}"
            }
        },
      },
      "event": "edit",
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "productStoreId",
      "description" : "",
      "style" : "",
      "id" : "UpdateProductStoreCatalog_productStoreId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "fromDate",
      "description" : "",
      "style" : "",
      "id" : "UpdateProductStoreCatalog_fromDate",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2005:05:33.813",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "UpdateProductStoreCatalog",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "UpdateProductStoreCatalog_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "UpdateProductStoreCatalog_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "UpdateProductStoreCatalog",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "UpdateProductStoreCatalog_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "deleteLink",
      "alternate" : "",
      "description" : "Delete",
      "parameterList" : [ {
        "name" : "prodCatalogId"
      }, {
        "name" : "productStoreId"
      }, {
        "name" : "fromDate"
      } ],
      "id" : "UpdateProductStoreCatalog_deleteLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : "",
      "target" : "deleteProdCatalogStore"
    } ],
    "target" : "updateProdCatalogStore"
  },
  {
    "fieldSets" : [ {
      "fieldSetName" : "Default",
      "fields" : [ "productCategoryId", "prodCatalogCategoryTypeId", "fromDate", "thruDate", "sequenceNum", "deleteLink", "makeTopLink", "submitButton" ]
    } ],
    "columns" : [ {
      "name" : "productCategoryId",
      "title" : "Category ID"
    }, {
      "name" : "prodCatalogCategoryTypeId",
      "title" : "Product Catalog Category Type"
    }, {
      "name" : "fromDate",
      "title" : "From Date  Time"
    }, {
      "name" : "thruDate",
      "title" : "Through Date  Time"
    }, {
      "name" : "sequenceNum",
      "title" : "Sequence Num"
    }, {
      "name" : "deleteLink",
      "title" : " "
    }, {
      "name" : "makeTopLink",
      "title" : " "
    }, {
      "name" : "submitButton",
      "title" : "Update"
    } ],
    "formName" : "EditProdCatalogCategories",
    "altTarget" : [ ],
    "formLocation" : "component://kwikstore/widget/ProdCatalogForms.xml",
    "type" : "list",
    "fields" : [ {
      "conditionGroup" : "",
      "name" : "prodCatalogId",
      "action" : "",
      "id" : "EditProdCatalogCategories_prodCatalogId",
      "type" : "HIDDEN",
      "event" : "",
      "value" : ""
    }, {
      "hyperlink" : {
        "linkStyle" : "buttontext",
        "description" : "",
        "targetType" : "intra-app",
        "confirmation" : "",
        "parameterMap" : {
          "VIEW_SIZE_0" : "20",
          "VIEW_INDEX_0" : "0"
        },
        "uniqueItemName" : "Modal_a9667eb4_8592_404a_a073_36a0b339078c",
        "target" : "EditCategory",
        "targetWindow" : "",
        "remoteFormData":{
            "formData":{
                "formName":"EditCategory",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/categories/category/${productCategoryId}"
            }
        },
      },
      "event":"edit",
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "productCategoryId",
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_productCategoryId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "prodCatalogCategoryTypeId",
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_prodCatalogCategoryTypeId",
      "title" : "",
      "type" : "DISPLAY_ENTITY",
      "imageLocation" : ""
    }, {
      "fieldHelpText" : "",
      "ajaxEnabled" : false,
      "size" : 0,
      "name" : "fromDate",
      "description" : "",
      "style" : "",
      "id" : "EditProdCatalogCategories_fromDate",
      "title" : "",
      "type" : "DISPLAY",
      "imageLocation" : ""
    }, {
      "classString" : "",
      "shortDateInput" : "false",
      "ampmName" : "",
      "className" : "",
      "title" : "Through Date  Time",
      "type" : "DATE_TIME",
      "dateType" : "timestamp",
      "defaultDateTimeString" : "2024-08-24%2004:58:18.531",
      "timeDropdown" : "",
      "alert" : "false",
      "timeValues" : "",
      "formName" : "EditProdCatalogCategories",
      "timeDropdownParamName" : "thruDate",
      "timeMinutesName" : "",
      "disabled" : "false",
      "id" : "EditProdCatalogCategories_thruDate",
      "event" : "",
      "value" : "",
      "pmSelected" : "",
      "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
      "mask" : "",
      "hour1" : "0",
      "isTwelveHour" : "false",
      "fieldHelpText" : "",
      "hour2" : "0",
      "maxlength" : "30",
      "minutes" : "0",
      "tabindex" : "",
      "amSelected" : "",
      "size" : "25",
      "isXMLHttpRequest" : "false",
      "localizedIconTitle" : "View Calendar",
      "timeHourName" : "",
      "name" : "thruDate",
      "style" : "",
      "step" : "1",
      "compositeType" : ""
    }, {
      "" : "",
      "fieldHelpText" : "",
      "textSize" : "6",
      "ajaxUrl" : "",
      "maxlength" : "",
      "tabindex" : "",
      "className" : "",
      "title" : "Sequence Num",
      "type" : "TEXT",
      "clientAutocomplete" : "true",
      "ajaxEnabled" : true,
      "readonly" : false,
      "alert" : "false",
      "name" : "sequenceNum",
      "action" : "",
      "style" : "",
      "disabled" : false,
      "id" : "EditProdCatalogCategories_sequenceNum",
      "placeholder" : "",
      "event" : "",
      "value" : "",
      "mask" : ""
    }, {
      "image" : "",
      "width" : "",
      "name" : "deleteLink",
      "alternate" : "",
      "description" : "Delete",
      "parameterList" : [ {
        "name" : "prodCatalogId"
      }, {
        "name" : "productCategoryId"
      }, {
        "name" : "partyId"
      }, {
        "name" : "fromDate"
      }, {
        "name" : "prodCatalogCategoryTypeId"
      } ],
      "id" : "EditProdCatalogCategories_deleteLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : "",
      "target" : "removeProductCategoryFromProdCatalog"
    }, {
      "image" : "",
      "width" : "",
      "name" : "makeTopLink",
      "alternate" : "",
      "description" : "MakeTop",
      "parameterList" : [ {
        "fromField" : {
          "isEmpty" : false,
          "original" : "productCategoryId",
          "bracketedOriginal" : "${productCategoryId}",
          "isAscending" : true,
          "empty" : false,
          "originalName" : "productCategoryId"
        },
        "name" : "CATALOG_TOP_CATEGORY"
      }, {
        "name" : "productCategoryId"
      } ],
      "id" : "EditProdCatalogCategories_makeTopLink",
      "imageTitle" : "",
      "parameterMap" : { },
      "height" : "",
      "target" : "EditCategory"
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "EditProdCatalogCategories",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "EditProdCatalogCategories_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "Update",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "updateProductCategoryToProdCatalog"
  },
  {
    "name" : "FindCatalog",
    "altTarget" : [ ],
    "formLocation" : "component://product/widget/catalog/ProdCatalogForms.xml",
    "fields" : [ {
      "maxlength" : "",
      "autocomplete" : "",
      "tabindex" : "",
      "conditionGroup" : "",
      "defaultOption" : "contains",
      "opEquals" : "Equals",
      "opNotEqual" : "Not Equal",
      "className" : "",
      "type" : "TEXTQBE",
      "opBeginsWith" : "Begins With",
      "opContains" : "Contains",
      "opIsEmpty" : "Is Empty",
      "size" : "25",
      "alert" : "false",
      "ignoreCase" : "Ignore Case",
      "name" : "prodCatalogId",
      "hideIgnoreCase" : "false",
      "titleStyle" : "",
      "value" : "",
      "ignCase" : "true"
    }, {
      "fieldHelpText" : "",
      "maxlength" : "",
      "autocomplete" : "",
      "tabindex" : "",
      "conditionGroup" : "",
      "defaultOption" : "contains",
      "opEquals" : "Equals",
      "opNotEqual" : "Not Equal",
      "className" : "",
      "title" : "Catalog Name",
      "type" : "TEXTQBE",
      "opBeginsWith" : "Begins With",
      "opContains" : "Contains",
      "opIsEmpty" : "Is Empty",
      "size" : "25",
      "alert" : "false",
      "ignoreCase" : "Ignore Case",
      "name" : "catalogName",
      "hideIgnoreCase" : "false",
      "style" : "",
      "titleStyle" : "",
      "id" : "FindCatalog_catalogName",
      "value" : "",
      "ignCase" : "true"
    }, {
      "buttonType" : "button",
      "alert" : "false",
      "formName" : "FindCatalog",
      "tabindex" : "",
      "name" : "submitButton",
      "className" : "smallSubmit",
      "id" : "FindCatalog_submitButton",
      "confirmation" : "",
      "type" : "SUBMIT",
      "title" : "",
      "event" : "",
      "imgSrc" : ""
    } ],
    "target" : "FindCatalog"
  },










]